import { RHFNestedFormProvider } from '@openx/components-core/lib/Form/context/RHFNestedFormContext';
import { PackageForm } from '@openx/components-package/components/PackageForm/PackageForm';
import type { UnionOfSectionNames } from '@openx/components-package/components/PackageForm/PackageForm.sections';
import { dealFormField } from '@openx/types/deal';
import { Fragment, useEffect, useState } from 'react';
import { type FieldValues, useFormContext, useWatch } from 'react-hook-form';
import { useDealFormContext } from '../../../DealForm.context';

type NewTargetingPackageTabProps = {
  currency: string;
};

export const NewTargetingPackageTab = ({ currency }: NewTargetingPackageTabProps) => {
  const { pckgInitialValues } = useDealFormContext();
  const {
    formState: { isSubmitting },
  } = useFormContext();
  /** RHF defaultValues object is mutable, therefore clone the object data */
  const [packageFormDefaultValues, setPackageFormDefaultValues] = useState(structuredClone(pckgInitialValues));
  const observableAccountUid = useWatch({ name: dealFormField.ACCOUNT_UID });

  useEffect(() => {
    if (!pckgInitialValues) {
      return;
    }

    setPackageFormDefaultValues(structuredClone(pckgInitialValues));
  }, [pckgInitialValues]);

  if (!pckgInitialValues) {
    return null;
  }

  return (
    <>
      {packageFormDefaultValues && (
        <Fragment key={JSON.stringify(packageFormDefaultValues)}>
          <RHFNestedFormProvider<FieldValues, UnionOfSectionNames>
            namespace="targeting"
            sections={{
              Targeting: {
                contentOnly: true,
              },
            }}
            formConfig={{
              noActions: true,
              noWrapper: true,
            }}
          >
            <PackageForm
              initialValues={packageFormDefaultValues}
              isSubmitting={isSubmitting}
              currency={currency}
              accountUid={observableAccountUid}
            />
          </RHFNestedFormProvider>
        </Fragment>
      )}
    </>
  );
};
